e.SSO.access_logs = {
	url : config.api + 'sso',
	offset : 10, //first ten loaded by PHP

	button : {},
	template : {},


	init : function(){
		_.bindAll( this, '_load_more', '_render' );

		this.button = $( '#more-access-logs' );
		if( this.button.length ){
			this.template = Handlebars.compile( $( '#access-logs-template' ).html() );

			this.button.on( 'click', this._load_more );
		}

	},


	/**
	 * Load More button has been clicked.
	 * Send the ajax request for more items then hand
	 * off the result to this._render
	 *
	 * @uses this._render
	 * @private
	 */
	_load_more : function(){
		var $data = {
			offset : this.offset,
			method : 'get_access_logs'
		};
		$.post( this.url, $data, this._render );
	},


	/**
	 * Append the new items to the bottom of the access logs
	 * Bump the offset so we can keep track of the page
	 * Kill the more button if we got less then 10 last time
	 *
	 * @uses called when ajax finishes on this._load_more()
	 *
	 * @param {object} data
	 * @private
	 */
	_render : function( data ){
		// @ifdef DEBUG
		console.info( data );
		// @endif
		this.offset = this.offset + 10;
		var $html = this.template( data );

		this.button.before( $html );

		if( data.count < 10 || typeof( data.count ) == 'undefined' ){
			this.button.remove();
		}
	}

};